<!--  -->
<template>
  <div>
    <div style="margin: 20px;" />
    <el-form label-position="right" label-width="80px" :model="formLabelAlign">
      <el-form-item label="企业名称">
        <el-select v-model="formLabelAlign.corp_id" placeholder="请选择" @change="seraw">
          <el-option
            v-for="item in corpidoptions"
            :key="item.corp_id"
            :label="item.corp_name"
            :value="item.corp_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="员工名称">
        <el-select v-model="formLabelAlign.corp_user_id" placeholder="请选择" :disabled="formLabelAlign.corp_id===null">
          <el-option
            v-for="item in corpuseridoptions"
            :key="item.user_id"
            :label="item.name"
            :value="item.user_id"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbit">确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { filterCorplist, filterUser, phoneRelationstore } from '@/api/mobilePhoneScanningCode.js'
export default {
  components: {},
  data() {
    return {
      formLabelAlign: {
        corp_id: null,
        phone_id: null,
        corp_user_id: null
      },
      corpidoptions: [],
      corpuseridoptions: []
    }
  },
  created() {
    // this.list()
  },
  mounted() {

  },
  methods: {
    send(id) {
      this.formLabelAlign.phone_id = id
      this.list()
    },
    async list() {
      const data = await filterCorplist()
      this.corpidoptions = data.data
      console.log('data', data)
    },
    async sdawr() {
      const data = await filterUser({
        corp_id: this.formLabelAlign.corp_id
      })
      this.corpuseridoptions = data.data
      console.log('data', data)
    },
    seraw() {
      this.formLabelAlign.corp_user_id = null
      this.corpuseridoptions = []
      this.sdawr()
    },
    async sumbit() {
      if (this.formLabelAlign.corp_id === null) {
        this.$message({
          message: '请选择企业名称',
          type: 'error'
        })
        return
      }
      if (this.formLabelAlign.corp_user_id === null) {
        this.$message({
          message: '请选择员工名称',
          type: 'error'
        })
        return
      }
      const data = await phoneRelationstore(this.formLabelAlign)
      this.$emit('updata')
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.el-form-item{
  overflow:visible;
}
</style>
